import { get } from "lodash-es";
import { CompanyId } from "../../core/config/config.enum.es.js";
let config;
const wsBase = "https://websupport";
const websupport = {
  help: {
    sv: `${wsBase}.se/support`,
    hu: `${wsBase}.hu/tamogatas`,
    sk: `${wsBase}.sk/podpora`,
    cs: `${wsBase}.cz/podpora`,
    en_se: `${wsBase}.se/en/support`,
    en: `${wsBase}.se/en/support`
  },
  contact: {
    sv: `${wsBase}.se/support`,
    hu: `${wsBase}.hu/kapcsolat`,
    sk: `${wsBase}.sk/kontakt`,
    cs: `${wsBase}.cz/kontakt`,
    en_se: `${wsBase}.se/en/support`,
    en: `${wsBase}.se/en/support`
  },
  terms: {
    sv: `${wsBase}.se/om-websupport/avtalsvillkor`,
    hu: `${wsBase}.hu/aszf`,
    sk: `${wsBase}.sk/obchodne-podmienky`,
    cs: `${wsBase}.cz/obchodni-podminky`,
    en_se: `${wsBase}.se/en/about-websupport/terms-and-conditions`,
    en: `${wsBase}.se/en/about-websupport/terms-and-conditions`
  },
  privacy: {
    sv: `${wsBase}.se/om-websupport/dataskyddspolicy`,
    hu: `${wsBase}.hu/adatvedelem`,
    sk: `${wsBase}.sk/sukromie`,
    cs: `${wsBase}.cz/soukromi`,
    en_se: `${wsBase}.se/en/about-websupport/terms-and-conditions`,
    en: `${wsBase}.se/en/about-websupport/data-protection`
  },
  webadmin: {
    sv: "https://auth.websupport.se/?s=admin&l=sv&c=websupport.se&account=standard",
    hu: "https://login.websupport.hu/?s=admin&l=hu&c=websupport.hu&account=standard",
    sk: "https://login.websupport.sk/?s=admin&l=sk&c=websupport.sk&account=standard",
    cs: "https://login.websupport.cz/?s=admin&l=cs&c=websupport.cz&account=standard",
    en_se: "https://auth.websupport.se/?s=admin&l=en&c=websupport.se&account=standard",
    en: "https://auth.websupport.se/?s=admin&l=en&c=websupport.se&account=standard"
  },
  webadmin_email: {
    sv: "https://auth.websupport.se/?s=admin&l=sv&c=websupport.se&account=email",
    hu: "https://login.websupport.hu/?s=admin&l=hu&c=websupport.hu&account=email",
    sk: "https://login.websupport.sk/?s=admin&l=sk&c=websupport.sk&account=email",
    cs: "https://login.websupport.cz/?s=admin&l=cs&c=websupport.cz&account=email",
    en_se: "https://auth.websupport.se/?s=admin&l=en&c=websupport.se&account=email",
    en: "https://auth.websupport.se/?s=admin&l=en&c=websupport.se&account=email"
  }
};
const active24 = {
  help: {
    sk: "https://www.active24.cz/centrum-napovedy",
    cs: "https://www.active24.cz/centrum-napovedy",
    en: "https://faq.active24.eu"
  },
  contact: {
    sk: "https://www.active24.sk/o-spolocnosti/kontakty",
    cs: "https://www.active24.cz/o-spolecnosti/kontakty",
    en: "https://active24.eu/kontakt"
  },
  terms: {
    sk: "https://www.active24.sk/o-spolocnosti/obchodne-podmienky",
    cs: "https://www.active24.cz/o-spolecnosti/obchodni-podminky",
    en: "https://active24.eu/obchodni-podminky"
  },
  privacy: {
    sk: "https://www.active24.sk/privacy",
    cs: "https://www.active24.cz/o-spolecnosti/soukromi",
    en: "https://active24.eu/obchodni-podminky"
  },
  webadmin: {
    sk: "https://login.active24.sk/?s=admin&l=sk&c=active24.cz&account=standard",
    cs: "https://login.active24.cz/?s=admin&l=cs&c=active24.cz&account=standard",
    en: "https://login.active24.eu/?s=admin&l=en&c=active24.eu&account=standard"
  },
  webadmin_email: {
    sk: "https://login.active24.sk/?s=admin&l=sk&c=active24.cz&account=email",
    cs: "https://login.active24.cz/?s=admin&l=cs&c=active24.cz&account=email",
    en: "https://login.active24.eu/?s=admin&l=en&c=active24.eu&account=email"
  }
};
const loopiaBase = "https://loopia";
const loopia = {
  help: {
    sv: `${loopiaBase}.se/support`,
    en_se: `${loopiaBase}.com/support`
  },
  contact: {
    sv: `${loopiaBase}.se/support`,
    en_se: `${loopiaBase}.com/support`
  },
  terms: {
    sv: `${loopiaBase}.se/avtalsvillkor`,
    en_se: `${loopiaBase}.com/terms-and-conditions/`
  },
  privacy: {
    sv: `${loopiaBase}.se/omloopia/dataskydd/`,
    en_se: `${loopiaBase}.com/aboutloopia/data-protection/`
  },
  webadmin: {
    sv: "https://www.loopia.se/loggain/",
    en_se: "https://www.loopia.com/login/"
  },
  webadmin_email: {
    sv: "https://www.loopia.se/loggain/",
    en_se: "https://www.loopia.com/login/"
  }
};
const googleTermsOfServiceBaseUrl = "https://policies.google.com/terms?hl=";
const googlePrivacyBaseUrl = "https://policies.google.com/privacy?hl=";
let adminBase = "https://admin.websupport";
const globalUrls = () => {
  return {
    // Maybe needs to be moved to the company-specific part
    admin: {
      sv: `${adminBase}.se`,
      hu: `${adminBase}.hu`,
      sk: `${adminBase}.sk`,
      cs: `${adminBase}.cz`,
      en_se: `${adminBase}.se/en`,
      en: `${adminBase}.se/en`
    },
    googleTermsOfService: {
      sv: `${googleTermsOfServiceBaseUrl}sv`,
      hu: `${googleTermsOfServiceBaseUrl}hu`,
      sk: `${googleTermsOfServiceBaseUrl}sk`,
      cs: `${googleTermsOfServiceBaseUrl}cs`,
      en_se: `${googleTermsOfServiceBaseUrl}en`,
      en: `${googleTermsOfServiceBaseUrl}en`
    },
    googlePrivacy: {
      sv: `${googlePrivacyBaseUrl}sv`,
      hu: `${googlePrivacyBaseUrl}hu`,
      sk: `${googlePrivacyBaseUrl}sk`,
      cs: `${googlePrivacyBaseUrl}cs`,
      en_se: `${googlePrivacyBaseUrl}en`,
      en: `${googlePrivacyBaseUrl}en`
    }
  };
};
const company = {
  ws: websupport,
  lp: loopia,
  a24: active24,
  global: globalUrls()
};
const nativeLangMap = {
  "sk-ws": "sk",
  "cz-ws": "cs",
  "cz-a24": "cs",
  "hu-ws": "hu",
  "se-ws": "sv"
};
const getLangCode = (lang) => {
  let urlLang = lang.split("-").shift() || "";
  if ([CompanyId.WEBSUPPORT_SE, CompanyId.LOOPIA_SE].includes(config.company) && urlLang === "en") {
    urlLang += "_se";
  }
  return urlLang;
};
const getTLD = (url) => {
  return new URL(url).hostname.split(".").pop() || "";
};
const replaceLanguage = (key, currentLanguage) => {
  const tld = getTLD(window.location.href);
  const locale = currentLanguage === "en_se" ? "en" : currentLanguage;
  const adminUrl = get(company, [config.company, key, tld]);
  if (!adminUrl) {
    return void 0;
  }
  const url = new URL(adminUrl);
  url.searchParams.set("l", locale);
  return url.toString();
};
function setupUrls(_config) {
  config = _config;
  adminBase = [CompanyId.LOOPIA_SE, CompanyId.LOOPIA_NO].includes(config.company) ? "https://admin.loopia" : "https://admin.websupport";
}
function getUrl(key, lang) {
  var _a;
  const currentLanguage = getLangCode(lang);
  const companyId = ((_a = config == null ? void 0 : config.company) == null ? void 0 : _a.id) || "";
  const companyCode = (companyId == null ? void 0 : companyId.split("-").pop()) || "";
  const isEnUs = lang === "en-US";
  const needsNativeFallback = [
    CompanyId.WEBSUPPORT_SK,
    CompanyId.SK_WEBSUPPORT_CZ,
    CompanyId.WEBSUPPORT_HU
  ].includes(companyId);
  const companySpecific = isEnUs && needsNativeFallback ? get(company, [companyCode, key, nativeLangMap[companyId]]) : get(company, [companyCode, key, currentLanguage]);
  if (key === "webadmin" || key === "webadmin_email") {
    const adminUrl = replaceLanguage(key, currentLanguage);
    if (adminUrl) {
      return adminUrl;
    }
  }
  if (companySpecific) {
    return companySpecific;
  }
  const generic = get(company, ["global", key, currentLanguage]);
  if (!generic) {
    console.error(`Url '${key}' not defined!`);
  }
  return generic;
}
export {
  getUrl,
  setupUrls
};
//# sourceMappingURL=urls.es.js.map
